<template>
  <div class="tabs is-large">
    <ul>
      <li v-bind:class="[{'is-active': this.name == 'overview'}]"><router-link :to="'../../season-stats/overview'">Overview</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'points'}]"><router-link :to="'../../season-stats/points'">Points</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'plus-minus'}]"><router-link :to="'../../season-stats/plus-minus'">Plus / Minus</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'penalty-minutes'}]"><router-link :to="'../../season-stats/penalty-minutes'">Penalty Minutes</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'shots'}]"><router-link :to="'../../season-stats/shots'">Shots</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'shot-differentials'}]"><router-link :to="'../../season-stats/shot-differentials'">Shot Differentials</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'faceoffs'}]"><router-link :to="'../../season-stats/faceoffs'">Faceoffs</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'turnovers'}]"><router-link :to="'../../season-stats/turnovers'">Turnovers</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'hits'}]"><router-link :to="'../../season-stats/hits'">Hits</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'time-on-ice'}]"><router-link :to="'../../season-stats/time-on-ice'">Time On Ice</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'zone-entries'}]"><router-link :to="'../../season-stats/zone-entries'">Zone Entries / Exits</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'zone-starts'}]"><router-link :to="'../../season-stats/zone-starts'">Zone Starts</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'raw-data'}]"><router-link :to="'../../season-stats/raw-data'">Raw Data</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'per-sixty'}]"><router-link :to="'../../season-stats/per-sixty'">Per Sixty Comparison Tool</router-link></li>
      <li v-bind:class="[{'is-active': this.name == 'vs-team'}]"><router-link :to="'../../season-stats/vs-team'">VS Team</router-link></li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['name'],
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// season-totals-menu.vue?12095d94